import { useTranslation } from 'react-i18next'

interface Props {
  expanded: boolean
  controlsId: string
  onClick: () => void
  disabled?: boolean
}

export function SolutionPreviewToggle({
  expanded,
  controlsId,
  onClick,
  disabled = false,
}: Props) {
  const { t } = useTranslation('coaching')

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        data-testid="solution-preview-toggle"
        aria-expanded={expanded}
        aria-controls={controlsId}
        onClick={onClick}
        disabled={disabled}
        className="rounded-md border border-sky-300 bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-800 hover:bg-sky-100 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {expanded ? t('solutionPreview.returnToSolve') : t('solutionPreview.show')}
      </button>
      <span role="status" aria-live="polite" className="sr-only">
        {expanded ? t('solutionPreview.opened') : t('solutionPreview.closed')}
      </span>
    </div>
  )
}
